import { inject, Injectable } from '@angular/core';
import { API_CONFIG, ApiCallingV2Service } from '@zayan-erp/shared';
import { Observable } from 'rxjs';

export interface TaxRateDto {
  id: string;
  taxCategoryDescription: string;
  taxCategoryCode: string;
  taxAuthorityId: string;
  taxCategoryId: string;
  effectiveDate: string;
  rate: number;
  taxAmount: number;
  createdAt: string;
  lastModified: string | null;
  createdByUserId: string | null;
  updatedByUserId: string | null;
}

export interface TaxRateCreateDto {
  taxAuthorityId: string;
  taxCategoryId: string;
  effectiveDate: string | null;
  rate: number;
}

export type TaxRateUpdateDto = TaxRateCreateDto;

@Injectable({
  providedIn: 'root'
})
export class TaxRatesService {
  #http = inject(ApiCallingV2Service);
  #apiConfig = inject(API_CONFIG);
  baseUrl = this.#apiConfig.baseUrlV2;

  readTaxRates(taxAuthorityId: string, taxCategoryId: string, showLoader: boolean = false): Observable<TaxRateDto[]> {
    return this.#http.getData(
      `${this.baseUrl}/TaxRate?taxAuthorityId=${taxAuthorityId}&taxCategoryId=${taxCategoryId}`,
      { showLoader, showMessage: false }
    );
  }

  getTaxRateById(id: string): Observable<TaxRateDto> {
    return this.#http.getData(`${this.baseUrl}/TaxRate/${id}`, { showLoader: true, showMessage: true });
  }

  createTaxRate(payload: TaxRateCreateDto): Observable<TaxRateDto> {
    return this.#http.postData(
      `${this.baseUrl}/TaxRate`,
      { showLoader: true, showMessage: true, message: 'Tax Rate created successfully' },
      payload
    );
  }

  updateTaxRate(id: string, payload: TaxRateUpdateDto): Observable<TaxRateDto> {
    return this.#http.putData(`${this.baseUrl}/TaxRate/${id}`, payload, {
      showLoader: true,
      showMessage: true,
      message: 'Tax Rate updated successfully'
    });
  }

  deleteTaxRate(id: string): Observable<void> {
    return this.#http.deleteData(`${this.baseUrl}/TaxRate/${id}`, {
      showLoader: true,
      showMessage: true,
      message: 'Tax Rate deleted successfully'
    });
  }
}
